import { ArrowDownward } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

interface ScrollToBottomContainerProps {
  children: React.ReactNode;
  sx?: any; // pour override MUI Box styles
  showButtonToBottom?: boolean;
}

export const ScrollToBottomContainer: React.FC<
  ScrollToBottomContainerProps
> = ({ children, sx = {}, showButtonToBottom }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isAtBottom, setIsAtBottom] = useState(true);

  // Gère le scroll auto si on est déjà en bas
  useEffect(() => {
    if (isAtBottom && scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [children]);

  // Détection du scroll manuel
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const atBottom = scrollHeight - scrollTop - clientHeight < 50;
      setIsAtBottom(atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Box
        ref={scrollRef}
        sx={{
          overflowY: "auto",
          flex: 1,
          position: "relative",
          ...sx,
        }}
      >
        {children}
      </Box>

      {!isAtBottom && showButtonToBottom && (
        <Box
          onClick={scrollToBottom}
          sx={{
            position: "fixed",
            height: "40px",
            width: "40px",
            bottom: "166px",
            transform: "translateX(-50%)",
            backgroundColor: "hsl(var(--card))",
            boxShadow: 3,
            borderRadius: "50%",
            p: 1,
            cursor: "pointer",
            zIndex: 1000,
            ":hover": {
              backgroundColor: "hsl(var(--muted))",
            },
          }}
        >
          <ArrowDownward
            sx={{
              fontSize: 24,
              color: "hsl(var(--foreground))",
            }}
          />
        </Box>
      )}
    </>
  );
};
